// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "07fe5db98ec799ac0718068b98b3352ab092fea9/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};